import PdfTitle from "./general/PdfTitle";
import BillTo from "./general/BillTo";
import PdfNo from "./general/PdfNo";
import PdfItemsTable from "./table/PdfItemsTable";
import PdfThankYouMsg from "./general/PdfThankYouMsg";
import { Document, Font, Image, Page, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
});

const styles = StyleSheet.create({
  page: {
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
    fontFamily: "Roboto",
  },
  logo: {
    width: 74,
    height: 66,
    marginLeft: "auto",
    marginRight: "auto",
  },
});

export const PdfDocument = ({
  tableData,
  title,
  userDetail,
  invoiceNo,
  orientation,
  message,
  logo,
  calcSum,
  customStyle,
  size = "A4",
  pageStyle,
}) => (
  <Document>
    <Page
      size={size}
      style={[styles.page, pageStyle]}
      orientation={orientation}
    >
      {logo && <Image style={styles.logo} src={logo} />}
      {title && <PdfTitle title={title} />}
      {invoiceNo && <PdfNo data={invoiceNo} />}
      {userDetail && <BillTo data={userDetail} />}
      {tableData && (
        <PdfItemsTable
          data={tableData}
          sum={!!calcSum}
          customStyle={customStyle}
        />
      )}
      {message && <PdfThankYouMsg data={message} />}
    </Page>
  </Document>
);
